export const translations = _.get(window, 'wix.translations', {});



// WEBPACK FOOTER //
// ./src/i18n/translations.js